import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, Instagram, Facebook, Twitter, ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const [isMobileHelpfulInfoOpen, setIsMobileHelpfulInfoOpen] = useState(false);
  const [isMobileProductsOpen, setIsMobileProductsOpen] = useState(false);
  const servicePages = [{
    name: 'Screen Printing',
    path: '/Screen-Printing'
  }, {
    name: 'Award Winning Embroidery',
    path: '/Embroidery-Options'
  }, {
    name: 'Direct to Film',
    path: '/Direct-to-Film'
  }, {
    name: 'Laser Engraving',
    path: '/Laser-Cutting-Engraving'
  }, {
    name: 'Direct To Garment',
    path: '/Direct-to-Garment'
  }, {
    name: 'Heat Transfer',
    path: '/Heat-Transfer'
  }, {
    name: 'Laser Etching',
    path: '/Laser-Etching'
  }, {
    name: 'Laser Embroidery',
    path: '/Laser-Embroidery'
  }, {
    name: 'Graphic Design',
    path: '/Graphic-Design'
  }, {
    name: 'Business Cards & Product Labels',
    path: '/Business-Cards-Product-Labels'
  }, {
    name: 'Decals',
    path: '/Custom-Decals'
  }, {
    name: 'Vehicle, Walls and Windows Decals',
    path: '/Vehicle-Wall-and-Windows'
  }, {
    name: 'Vehicle Magnets - Business Advertising',
    path: '/Vehicle-Magnets-Business-Advertising'
  }, {
    name: 'Banners',
    path: '/Banners'
  }, {
    name: 'Yard Signs',
    path: '/Yard-Signs'
  }, {
    name: 'Promotional Products',
    path: '/services/promotional-products'
  }, {
    name: 'Personalized Products',
    path: '/Personalized-Products'
  }];
  const helpfulInfoPages = [{
    name: 'FAQs',
    path: '/12.html'
  }, {
    name: 'Compliance',
    path: '/Compliance'
  }, {
    name: 'Screen Printing Advice',
    path: '/Screen-Printing-Advice'
  }, {
    name: 'What is Vector Art?',
    path: '/What-is-Vector-Art'
  }, {
    name: 'The Wear Haus Way',
    path: '/The-Wear-Haus-Way'
  }, {
    name: 'Terms and Conditions',
    path: '/Terms'
  }, {
    name: 'Privacy Policy',
    path: '/Privacy'
  }];
  const productPages = [{
    name: 'Banners',
    path: '/Banners'
  }, {
    name: 'Product Catalogs',
    path: '/ProductCatalogs.html'
  }, {
    name: 'Camp Designs',
    path: '/Camp-Designs'
  }, {
    name: 'Monthly Special',
    path: '/Monthly-Special'
  }];
  const navItems = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services',
    hasDropdown: true,
    dropdownItems: servicePages
  }, {
    name: 'Helpful Info',
    path: '/helpful-info',
    hasDropdown: true,
    dropdownItems: helpfulInfoPages
  }, {
    name: 'Products',
    path: '/products',
    hasDropdown: true,
    dropdownItems: productPages
  }, {
    name: 'About',
    path: '/About-Us'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => {
    if (path === '/services') {
      return location.pathname === '/services' || location.pathname.startsWith('/services/');
    }
    if (path === '/helpful-info') {
      return location.pathname === '/helpful-info' || location.pathname.startsWith('/helpful-info/');
    }
    if (path === '/products') {
      return location.pathname === '/products' || location.pathname.startsWith('/products/');
    }
    return location.pathname === path;
  };
  return <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm" data-id="element-202">
      {/* Main Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="flex justify-between items-center" style={{
        height: '74px'
      }} data-id="element-204">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center" style={{
          margin: '5px 0'
        }} data-id="element-205">
            <img src="https://www.wearhaus.net/uploaded%2Fimages%2FRedesign%2FWearHausDesigns-logo%201.png" alt="Wear Haus Designs" className="w-auto" style={{
            height: '57.6px'
          }} data-id="element-206" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-5" data-id="element-207">
            {navItems.map(item => item.hasDropdown ? <div key={item.path} className="relative group" data-id="element-208">
                  <Link to={item.path === '/products' ? '#' : item.path} className={`text-sm font-medium transition-colors hover:text-wh-pink flex items-center gap-1 ${isActive(item.path) ? 'text-wh-pink' : 'text-gray-700'}`} onClick={e => {
              // Prevent default link behavior for Products if it's just a dropdown trigger
              if (item.path === '/products') e.preventDefault();
            }} data-id="element-209">
                    {item.name}
                    <ChevronDown className="w-4 h-4" data-id="element-210" />
                  </Link>

                  {/* Dropdown Menu */}
                  <div className="absolute top-full left-0 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" data-id="element-211">
                    <div className="w-72 bg-white rounded-lg shadow-xl border border-gray-100 py-2" data-id="element-212">
                      {item.dropdownItems?.map(subItem => <Link key={subItem.path} to={subItem.path} className={`block w-full text-left px-4 py-2 text-sm transition-colors ${location.pathname === subItem.path ? 'text-wh-pink bg-pink-50' : 'text-gray-700 hover:text-wh-pink hover:bg-gray-50'}`} data-id="element-213">
                          {subItem.name}
                        </Link>)}
                    </div>
                  </div>
                </div> : <Link key={item.path} to={item.path} className={`text-sm font-medium transition-colors hover:text-wh-pink ${isActive(item.path) ? 'text-wh-pink' : 'text-gray-700'}`} data-id="element-214">
                  {item.name}
                </Link>)}
          </nav>

          {/* Desktop Icons & CTAs */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-215">
            {/* Contact & Social Icons */}
            <div className="flex items-center space-x-3 mr-4 pr-4 border-r border-gray-200" data-id="element-216">
              <a href="tel:260-463-7373" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Call us" data-id="element-217">
                <Phone className="w-4 h-4" data-id="element-218" />
              </a>
              <a href="mailto:wearhaus@wearhaus.net" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Email us" data-id="element-219">
                <Mail className="w-4 h-4" data-id="element-220" />
              </a>
              <a href="https://www.facebook.com/wearhausdesigns" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Facebook" data-id="element-221">
                <Facebook className="w-4 h-4" data-id="element-222" />
              </a>
              <a href="https://www.instagram.com/wear.haus.designs/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Instagram" data-id="element-223">
                <Instagram className="w-4 h-4" data-id="element-224" />
              </a>
              <a href="https://twitter.com/WearHausDesigns" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Twitter" data-id="element-225">
                <Twitter className="w-4 h-4" data-id="element-226" />
              </a>
            </div>

            {/* CTA Buttons */}
            <Link to="/Contact" data-id="element-227">
              <Button variant="outline" size="sm" data-id="element-228">
                Contact
              </Button>
            </Link>
            <Link to="/Contact" data-id="element-229">
              <Button variant="primary" size="sm" data-id="element-230">
                Get a Quote
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden" data-id="element-231">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-md text-gray-600 hover:text-wh-pink hover:bg-gray-100 focus:outline-none" data-id="element-232">
              {isMobileMenuOpen ? <X className="h-9 w-9" strokeWidth={2.5} data-id="element-233" /> : <Menu className="h-9 w-9" strokeWidth={2.5} data-id="element-234" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100" data-id="element-235">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-236">
            {navItems.map(item => item.hasDropdown ? <div key={item.path} data-id="element-237">
                  <button onClick={() => {
            if (item.path === '/services') {
              setIsMobileServicesOpen(!isMobileServicesOpen);
            } else if (item.path === '/helpful-info') {
              setIsMobileHelpfulInfoOpen(!isMobileHelpfulInfoOpen);
            } else if (item.path === '/products') {
              setIsMobileProductsOpen(!isMobileProductsOpen);
            }
          }} className={`flex items-center justify-between w-full text-left px-3 py-2 rounded-md text-base font-medium ${isActive(item.path) ? 'text-wh-pink bg-pink-50' : 'text-gray-700 hover:text-wh-pink hover:bg-gray-50'}`} data-id="element-238">
                    {item.name}
                    <ChevronDown className={`w-5 h-5 transition-transform ${item.path === '/services' && isMobileServicesOpen || item.path === '/helpful-info' && isMobileHelpfulInfoOpen || item.path === '/products' && isMobileProductsOpen ? 'rotate-180' : ''}`} data-id="element-239" />
                  </button>
                  {(item.path === '/services' && isMobileServicesOpen || item.path === '/helpful-info' && isMobileHelpfulInfoOpen || item.path === '/products' && isMobileProductsOpen) && <div className="pl-4 mt-1 space-y-1" data-id="element-240">
                      {item.dropdownItems?.map(subItem => <Link key={subItem.path} to={subItem.path} onClick={() => {
              setIsMobileMenuOpen(false);
              setIsMobileServicesOpen(false);
              setIsMobileHelpfulInfoOpen(false);
              setIsMobileProductsOpen(false);
            }} className={`block w-full text-left px-3 py-2 rounded-md text-sm ${location.pathname === subItem.path ? 'text-wh-pink bg-pink-50' : 'text-gray-600 hover:text-wh-pink hover:bg-gray-50'}`} data-id="element-241">
                          {subItem.name}
                        </Link>)}
                    </div>}
                </div> : <Link key={item.path} to={item.path} onClick={() => setIsMobileMenuOpen(false)} className={`block w-full text-left px-3 py-2 rounded-md text-base font-medium ${isActive(item.path) ? 'text-wh-pink bg-pink-50' : 'text-gray-700 hover:text-wh-pink hover:bg-gray-50'}`} data-id="element-242">
                  {item.name}
                </Link>)}

            {/* Mobile Contact Icons */}
            <div className="flex items-center justify-center space-x-6 py-4 border-t border-gray-100" data-id="element-243">
              <a href="tel:260-463-7373" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Call us" data-id="element-244">
                <Phone className="w-5 h-5" data-id="element-245" />
              </a>
              <a href="mailto:wearhaus@wearhaus.net" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Email us" data-id="element-246">
                <Mail className="w-5 h-5" data-id="element-247" />
              </a>
              <a href="https://www.facebook.com/wearhausdesigns" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Facebook" data-id="element-248">
                <Facebook className="w-5 h-5" data-id="element-249" />
              </a>
              <a href="https://www.instagram.com/wear.haus.designs/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Instagram" data-id="element-250">
                <Instagram className="w-5 h-5" data-id="element-251" />
              </a>
              <a href="https://twitter.com/WearHausDesigns" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-wh-pink transition-colors" aria-label="Twitter" data-id="element-252">
                <Twitter className="w-5 h-5" data-id="element-253" />
              </a>
            </div>

            <div className="pt-2 space-y-2 px-3" data-id="element-254">
              <Link to="/Contact" onClick={() => setIsMobileMenuOpen(false)} data-id="element-255">
                <Button variant="outline" className="w-full justify-center" data-id="element-256">
                  Contact
                </Button>
              </Link>
              <Link to="/Contact" onClick={() => setIsMobileMenuOpen(false)} data-id="element-257">
                <Button variant="primary" className="w-full justify-center" data-id="element-258">
                  Get a Quote
                </Button>
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}